const STREET_ABBREVIATIONS: Record<string, string> = {
  // A
  alley: "aly",
  allee: "aly",
  ally: "aly",
  anex: "anx",
  annex: "anx",
  annx: "anx",
  arcade: "arc",
  avenue: "ave",
  av: "ave",
  aven: "ave",
  avenu: "ave",
  avn: "ave",
  avnue: "ave",
  // B
  bayoo: "byu",
  bayou: "byu",
  beach: "bch",
  bend: "bnd",
  bluff: "blf",
  bluf: "blf",
  bluffs: "blfs",
  bottom: "btm",
  bot: "btm",
  bottm: "btm",
  boulevard: "blvd",
  boul: "blvd",
  boulv: "blvd",
  branch: "br",
  brnch: "br",
  bridge: "brg",
  brdge: "brg",
  brook: "brk",
  brooks: "brks",
  burg: "bg",
  burgs: "bgs",
  bypass: "byp",
  bypa: "byp",
  bypas: "byp",
  byps: "byp",
  // C
  camp: "cp",
  cmp: "cp",
  canyon: "cyn",
  canyn: "cyn",
  cnyn: "cyn",
  cape: "cpe",
  causeway: "cswy",
  causway: "cswy",
  center: "ctr",
  cen: "ctr",
  cent: "ctr",
  centr: "ctr",
  centre: "ctr",
  cnter: "ctr",
  cntr: "ctr",
  centers: "ctrs",
  circle: "cir",
  circ: "cir",
  circl: "cir",
  crcl: "cir",
  crcle: "cir",
  circles: "cirs",
  cliff: "clf",
  cliffs: "clfs",
  club: "clb",
  common: "cmn",
  commons: "cmns",
  corner: "cor",
  corners: "cors",
  course: "crse",
  court: "ct",
  courts: "cts",
  cove: "cv",
  coves: "cvs",
  creek: "crk",
  crescent: "cres",
  crsent: "cres",
  crsnt: "cres",
  crest: "crst",
  crossing: "xing",
  crssng: "xing",
  crossroad: "xrd",
  crossroads: "xrds",
  curve: "curv",
  // D
  dale: "dl",
  dam: "dm",
  divide: "dv",
  div: "dv",
  dvd: "dv",
  drive: "dr",
  driv: "dr",
  drv: "dr",
  drives: "drs",
  // E
  estate: "est",
  estates: "ests",
  expressway: "expy",
  exp: "expy",
  expr: "expy",
  express: "expy",
  expw: "expy",
  extension: "ext",
  extn: "ext",
  extnsn: "ext",
  extensions: "exts",
  // F
  fall: "fall",
  falls: "fls",
  ferry: "fry",
  frry: "fry",
  field: "fld",
  fields: "flds",
  flat: "flt",
  flats: "flts",
  ford: "frd",
  fords: "frds",
  forest: "frst",
  forests: "frst",
  forge: "frg",
  forg: "frg",
  forges: "frgs",
  fork: "frk",
  forks: "frks",
  fort: "ft",
  frt: "ft",
  freeway: "fwy",
  freewy: "fwy",
  frway: "fwy",
  frwy: "fwy",
  // G
  garden: "gdn",
  gardn: "gdn",
  grden: "gdn",
  grdn: "gdn",
  gardens: "gdns",
  grdns: "gdns",
  gateway: "gtwy",
  gatewy: "gtwy",
  gatway: "gtwy",
  gtway: "gtwy",
  glen: "gln",
  glens: "glns",
  green: "grn",
  greens: "grns",
  grove: "grv",
  grov: "grv",
  groves: "grvs",
  // H
  harbor: "hbr",
  harb: "hbr",
  harbr: "hbr",
  hrbor: "hbr",
  harbors: "hbrs",
  haven: "hvn",
  havn: "hvn",
  heights: "hts",
  ht: "hts",
  highway: "hwy",
  highwy: "hwy",
  hiway: "hwy",
  hiwy: "hwy",
  hway: "hwy",
  hill: "hl",
  hills: "hls",
  hollow: "holw",
  hllw: "holw",
  hollows: "holw",
  holws: "holw",
  // I
  inlet: "inlt",
  island: "is",
  islnd: "is",
  islands: "iss",
  islnds: "iss",
  isle: "isle",
  isles: "isle",
  // J
  junction: "jct",
  jction: "jct",
  jctn: "jct",
  juncion: "jct",
  junctn: "jct",
  junktion: "jct",
  junctions: "jcts",
  jctns: "jcts",
  // K
  key: "ky",
  keys: "kys",
  knoll: "knl",
  knol: "knl",
  knolls: "knls",
  // L
  lake: "lk",
  lakes: "lks",
  land: "land",
  landing: "lndg",
  lndng: "lndg",
  lane: "ln",
  light: "lgt",
  lights: "lgts",
  loaf: "lf",
  lock: "lck",
  locks: "lcks",
  lodge: "ldg",
  ldge: "ldg",
  lodg: "ldg",
  loop: "loop",
  loops: "loop",
  // M
  mall: "mall",
  manor: "mnr",
  manors: "mnrs",
  meadow: "mdw",
  meadows: "mdws",
  medows: "mdws",
  mews: "mews",
  mill: "ml",
  mills: "mls",
  mission: "msn",
  missn: "msn",
  mssn: "msn",
  motorway: "mtwy",
  mount: "mt",
  mnt: "mt",
  mountain: "mtn",
  mntain: "mtn",
  mntn: "mtn",
  mountin: "mtn",
  mtin: "mtn",
  mountains: "mtns",
  mntns: "mtns",
  // N
  neck: "nck",
  // O
  orchard: "orch",
  orchrd: "orch",
  oval: "oval",
  overpass: "opas",
  // P
  park: "park",
  prk: "park",
  parks: "park",
  parkway: "pkwy",
  parkwy: "pkwy",
  pkway: "pkwy",
  pky: "pkwy",
  parkways: "pkwy",
  pkwys: "pkwy",
  pass: "pass",
  passage: "psge",
  path: "path",
  paths: "path",
  pike: "pike",
  pikes: "pike",
  pine: "pne",
  pines: "pnes",
  place: "pl",
  plain: "pln",
  plains: "plns",
  plaines: "plns",
  plaza: "plz",
  plza: "plz",
  point: "pt",
  points: "pts",
  port: "prt",
  ports: "prts",
  prairie: "pr",
  prarie: "pr",
  prr: "pr",
  // R
  radial: "radl",
  rad: "radl",
  radiel: "radl",
  ramp: "ramp",
  ranch: "rnch",
  ranches: "rnch",
  rnchs: "rnch",
  rapid: "rpd",
  rapids: "rpds",
  rest: "rst",
  ridge: "rdg",
  rdge: "rdg",
  ridges: "rdgs",
  river: "riv",
  rvr: "riv",
  rivr: "riv",
  road: "rd",
  roад: "rd",
  roads: "rds",
  route: "rte",
  row: "row",
  rue: "rue",
  run: "run",
  // S
  shoal: "shl",
  shoals: "shls",
  shore: "shr",
  shoar: "shr",
  shores: "shrs",
  shoars: "shrs",
  skyway: "skwy",
  spring: "spg",
  spng: "spg",
  sprng: "spg",
  springs: "spgs",
  spngs: "spgs",
  sprngs: "spgs",
  spur: "spur",
  spurs: "spur",
  square: "sq",
  sqr: "sq",
  sqre: "sq",
  squ: "sq",
  squares: "sqs",
  sqrs: "sqs",
  station: "sta",
  staion: "sta",
  stravenue: "stra",
  stream: "strm",
  streme: "strm",
  street: "st",
  strt: "st",
  str: "st",
  streets: "sts",
  summit: "smt",
  sumit: "smt",
  sumitt: "smt",
  swamp: "swmp",
  // T
  terrace: "ter",
  terr: "ter",
  throughway: "trwy",
  trace: "trce",
  traces: "trce",
  track: "trak",
  tracks: "trak",
  trk: "trak",
  trks: "trak",
  trafficway: "trfy",
  trail: "trl",
  trails: "trl",
  trls: "trl",
  trailer: "trlr",
  trlrs: "trlr",
  tunnel: "tunl",
  tunel: "tunl",
  tunls: "tunl",
  tunnels: "tunl",
  tunnl: "tunl",
  turnpike: "tpke",
  trnpk: "tpke",
  trpk: "tpke",
  turnpk: "tpke",
  // U
  underpass: "upas",
  union: "un",
  unions: "uns",
  // V
  valley: "vly",
  vally: "vly",
  vlly: "vly",
  valleys: "vlys",
  viaduct: "via",
  vdct: "via",
  viadct: "via",
  view: "vw",
  views: "vws",
  village: "vlg",
  vill: "vlg",
  villag: "vlg",
  villg: "vlg",
  villiage: "vlg",
  villages: "vlgs",
  ville: "vl",
  vista: "vis",
  vist: "vis",
  vsta: "vis",
  // W
  walk: "walk",
  walks: "walk",
  wall: "wall",
  way: "wy",
  ways: "ways",
  well: "wl",
  wells: "wls",
};

export const expandAbbreviations = (input: string): string => {
  return input
    .split(" ")
    .map((word) => STREET_ABBREVIATIONS[word.toLowerCase()] ?? word)
    .join(" ");
};
